import { render, staticRenderFns } from "./viewerTable.vue?vue&type=template&id=f2449250&"
import script from "./viewerTable.vue?vue&type=script&lang=js&"
export * from "./viewerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports